// PublicSchedulePage Messages
export const INVALID_PARAMS_ERROR_MESSAGE = 'Invalid schedule parameters';
export const NO_GAMES_MESSAGE = 'No games in time period selected';
export const GENERIC_ERROR_MESSAGE = 'Something went wrong. Please try again.';
export const REFRESH_BUTTON_TEXT = 'Refresh';

// API Error Messages (Generic - used across all API calls)
export const API_ERROR_MESSAGES = {
  /**
   * Used when HTTP response is not OK (4xx, 5xx status codes)
   * Example: 404 Not Found, 500 Internal Server Error
   */
  FETCH_FAILED: 'Unable to load data',

  /**
   * Used when network request fails completely
   * Example: No internet connection, DNS failure, CORS error
   */
  NETWORK_ERROR: 'Network connection failed',

  /**
   * Used when request exceeds timeout limit
   * Example: Request takes longer than 10 seconds
   */
  TIMEOUT: 'Request timed out',

  /**
   * Used when response data format is invalid
   * Example: Expected JSON but got HTML, missing required fields
   */
  INVALID_RESPONSE: 'Invalid data format received',
} as const;

// Knockout level names, shared by the V2 schedule and the knockout view
export const KNOCKOUT_LEVEL_NAMES = {
  FINAL: 'Final',
  SEMIFINAL: 'Semifinal',
  QUARTERFINAL: 'Quarterfinal',
  /** Earlier rounds, named by the number of teams they start with. */
  ROUND_OF: (teamCount: number) => `Round of ${teamCount}`,
} as const;

// Schedule/Standings view toggle segment labels
export const VIEW_TOGGLE_LABELS = {
  SCHEDULE: 'Schedule',
  STANDINGS: 'Standings',
} as const;

// V2 schedule copy
export const SCHEDULE_V2_LABELS = {
  /** Team name of a side held by a knockout placeholder. */
  PLACEHOLDER_TEAM: 'TBD',
  /** Group column value of a group play game. */
  GROUP_PLAY_GROUP: (bracketName: string) => `Group ${bracketName}`,
  /** Section headers of the schedule Group filter. */
  GROUP_SECTION_GROUP_PLAY: 'Group Play',
  GROUP_SECTION_KNOCKOUT: 'Knockout',
  GROUP_SECTION_OTHER: 'Other',
} as const;
